import PropTypes from 'prop-types';
import React from 'react';
import I18n from 'common/i18n';
import _ from 'lodash';

export class BackButton extends React.Component {
  render() {
    return (
      <button className="btn btn-default btn-sm close-modal back-button" onClick={this.props.onClick}>
        <span className="socrata-icon-arrow-prev"></span>
        {` ${I18n.t('common.action_buttons.back')}`}
      </button>
    );
  }
}

BackButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

BackButton.defaultProps = {
  onClick: _.noop
};

export default BackButton;
